import TimeSelectPopper from './src/time-select-popper';

TimeSelectPopper.directive = TimeSelectPopper.component.Popper.directive;

export default TimeSelectPopper;
